export const acceptCompanyInviteAction = async () => {
  try {
    const response = await BX.ajax.runComponentAction(
      "nanocad.user:management",
      "includeCompany",
      {
        mode: "class",
        method: "POST",
        data: {},
      }
    );
    if (response.data.status !== "success") {
      return {
        isError: true,
        status: response.data.status,
        errorMessage: response.data.message,
      };
    }

    return response;
  } catch (error) {
    return {
      isError: true,
      status: "error",
      errorMessage: error.errors ? error.errors[0].message : error,
    };
  }
};
